import gql from 'graphql-tag';
import { credentials } from '@shootsta/client-auth';

const getFilteredVideosQuery = gql`
      query GetFilteredVideos($filter: OutputFilterInput, $limit: Int, $offset: Int, $sortBy: String, $organisationId: String!) {
        getFilteredVideos(filter: $filter, limit: $limit, offset: $offset, sortBy: $sortBy, organisationId: $organisationId) {
          count
          totalVideosCount
          videos {
            videoId
            organisationId
            videoProjectId
            requestedExtras
            appliedExtras
            readableId
            submittedAt
            clips {
              assetId
            }
            name
            creator {
              userId
              firstName
              lastName
              imageUrl
            }
            outputs {
              outputId
              videoId
              readableId
              status {
                name
              }
              aspectRatio
              isMaster
              onHoldDate
              onHoldReason
              name
              description
              tags
              latestVersion
              versions {
                versionNumber
                dueDate
                versionId
                assetId
              }
            }
          }
        }
      }
`;

function normaliseUserFilter(filter) {
  return filter.USER && filter.USER.includes('ALL') ?
  { ...filter, USER: void 0 } :
  { ...filter, USER: [credentials.get().user.userId] };
}

const getFilteredVideos = (organisationId) => ({
  query: getFilteredVideosQuery,
  module: 'video',
  ignoreCache: true,
  buildVariables: ({ limit, offset, sortBy, ...filter }) => ({
    filter: normaliseUserFilter(filter),
    limit,
    offset,
    sortBy,
    organisationId
  })
});

export default getFilteredVideos;